import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';

import css from './LoadingPlaceholder.module.css';

const WIDTHS = [70, 55, 80, 62, 48, 74];

/**
 * Grey shapes of the page's real layout while its data loads: `rows` for tables and lists,
 * `cards` for listing grids. Screen readers hear "Loading" once.
 */
const LoadingPlaceholder = ({ variant = 'rows', count = 5, className }) => {
  const items = Array.from({ length: count }, (_, i) => i);
  return (
    <div className={classNames(css.root, className)} role="status" aria-live="polite">
      <span className="visuallyHidden">
        <FormattedMessage id="LoadingPlaceholder.loading" />
      </span>
      {variant === 'cards' ? (
        <div className={css.cards} aria-hidden="true">
          {items.map(i => (
            <div key={i} className={css.card}>
              <span className={classNames(css.shape, css.cardImage)} />
              <span className={classNames(css.shape, css.line)} style={{ width: '80%' }} />
              <span className={classNames(css.shape, css.lineShort)} />
            </div>
          ))}
        </div>
      ) : (
        <div className={css.rows} aria-hidden="true">
          {items.map(i => (
            <div key={i} className={css.row}>
              <span className={classNames(css.shape, css.thumb)} />
              <span className={css.rowText}>
                <span
                  className={classNames(css.shape, css.line)}
                  style={{ width: `${WIDTHS[i % WIDTHS.length]}%` }}
                />
                <span className={classNames(css.shape, css.lineShort)} />
              </span>
              <span className={classNames(css.shape, css.pill)} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LoadingPlaceholder;
